module.exports = __webpack_public_path__ + "img/bg_fxyq.8feec406.png";